import * as React from 'react'
import { SaveButton, Toolbar, DeleteButton, usePermissions } from 'react-admin'

export const ArchivalToolbar = (props) => {
  const { permissions } = usePermissions()
  return (
    <Toolbar {...props} style={{ justifyContent: 'space-between' }}>
      <SaveButton submitOnEnter={true} />
      <div>
        <SaveButton
          label={props.record?.archived_at ? 'Unarchive' : 'Archive'}
          submitOnEnter={false}
          variant="text"
          transform={(data) => ({
            ...data,
            archived_at: props.record.archived_at
              ? null
              : new Date().toISOString(),
          })}
          handleSubmitWithRedirect={() => {
            if (
              !window.confirm(
                `Are you sure you want to ${
                  props.record?.archived_at ? 'unarchive' : 'archive'
                } this?`,
              )
            )
              return false
            return props.handleSubmitWithRedirect()
          }}
        />

        {permissions?.includes('admin') && (
          <DeleteButton
            {...props}
            undoable={props.undoable}
            record={props.record}
          />
        )}
      </div>
    </Toolbar>
  )
}
